module.exports = __webpack_public_path__ + "media/images/hero-bg-4d0efbcf5674f3f23dd8f7e5f6d81f96.jpg";